import { Geography } from '@/utilities/geography';
import { MASKS } from '@/utilities/constants';

export default {
  required: () => 'This is a required field.',
  txtMinLen: ({ $params }) => `Must be at least ${$params.min} characters.`,
  txtMaxLen: ({ $params }) => `Must be less or equal ${$params.max} characters.`,
  emailMaxLen: ({ $params }) => `Email addresses are limited to ${$params.max} characters in length.`,
  phoneNumberByCountry: ({ $params }) =>
    `Phone number should have the pattern ${$params.example}${!$params.isForeign ? ', excluding 1 at the beginning and cannot be an 800 number' : ''}.`,
  phoneNumber: () => 'Phone number needs to be a valid format.',
  email: () => 'Invalid email address.',
  fakeEmail: () => 'You must use a valid email address.',
  isValidPromotion: () => 'This is not a valid/active promotion code.',
  minValue: ({ $params }) => `Must be at least ${$params.min}.`,
  maxValue: ({ $params }) => `Must be no larger than ${$params.max}.`,
  sameAsPassword: () => "The passwords don't match.",
  sameAsEmail: () => "The emails don't match.",
  invalidAddress: () => "We couldn't validate your address, please make sure all the relevant information is provided.",
  ambiguousAddress: () => 'The address is ambiguous.',
  missingSecondaryAddress: () => 'The address is missing a secondary number.',
  poBoxAddress: () => 'The address must be a physical location and not a PO Box.',
  nonProfessional: () => 'We are able to open accounts for non-professionals only.',
  validDate: () => 'Invalid date',
  minimumAge: ({ $params }) => `Must be at least ${$params.min} years old.`,
  maximumAge: ({ $params }) => `Must be under ${$params.max} years of age.`,
  stockOptionExperience: () => 'Stock trading experience cannot be less than your option trading experience.',
  validCountry: ({ $model }) => {
    return `Unfortunately, we are unable to open accounts for residents
      of ${Geography.getCountry($model)} at this time.`;
  },
  notUsa: () =>
    'You must be a US Citizen or Permanent Resident to use a US address. If you are a US permanent resident, change this below.',
  notExceptionCountry: ({ $model }) => {
    return `We are unable to open accounts with ${Geography.getCountry($model)} addresses.`;
  },
  notValidResidentCountry: ({ $model }) => {
    return `We are unable to open accounts with ${Geography.getCountry($model)} addresses.`;
  },
  txtLegalName: ({ $params }) =>
    `Your full name should be less than ${$params.max} characters long, use initials if necessary.`,
  taxIdByCountry: ({ $params }) => `${$params.label} should have the pattern ${$params.example}.`,
  ssn: () => `SSN should have the pattern ${MASKS.ssn}.`,
  ssnBeneficiary: () => 'SSN for beneficiary must be unique.',
  validSharePercentValue: ({ $params }) => {
    const availableSharePercent = $params.availableSharePercent();

    if (availableSharePercent > 0) {
      return `Must be between 1 and ${availableSharePercent}.`;
    }

    return 'Total is already 100%';
  },
  noSpaces: () => 'Spaces are not allowed.',
  phoneNumberMinLength: () => 'Should be at least 10 digits, excluding extension (if any)',
  fullNameMaxLength: () => 'Full name cannot exceed 30 characters. Use initials if necessary.',
  validIdentificationIssueDate: () => 'Issue date must be less than 10 days from today.',
  validIdentificationExpirationDate: () => 'Expiration date must be greater than 10 days from today.',
  trustedContactDetails: () => 'Trusted contact cannot be the same as the primary account holder.',
  validCharacters: () => 'Only letters, spaces, hyphens, periods, and apostrophes are allowed.',
  notSameAsPassword: () => 'Username cannot be the same as password.',
  passwordPolicy: () =>
    'Password must be at least 12 characters long and contain at least one number and one special character.',
  jointDobAndSsn: () => 'Date of Birth and Social Security Number cannot be the same as the primary account holder.',
  ssnBlackList: () =>
    'Based on Tax ID provided, Tradier Brokerage is unable to open an account for you. Please contact service@tradierbrokerage.com for more information.',
  hasValidPlan: () =>
    'Based on the subscription plan you selected, futures is not available for this account. Please select a different plan.',
};
